import { KeyRound, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { testIds } from '@/lib/test-ids'
import { openAccountPasswordSettings } from '@/lib/open-settings'

type InboxPasswordSetupBannerProps = {
  onDismiss: () => void
}

export function InboxPasswordSetupBanner({ onDismiss }: InboxPasswordSetupBannerProps) {
  return (
    <div
      className="mx-2 mt-2 shrink-0 rounded-md border border-primary/25 bg-primary/5 px-3 py-2.5"
      data-testid={testIds.inbox.passwordSetupBanner}
    >
      <div className="flex items-start gap-2.5">
        <KeyRound className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <div className="min-w-0 flex-1 space-y-2">
          <div>
            <p className="text-sm font-medium text-foreground">Set your password</p>
            <p className="text-xs leading-relaxed text-muted-foreground">
              You signed in via invite. Add a password so you can sign in again after this session.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Button
              type="button"
              size="sm"
              data-testid={testIds.inbox.passwordSetupButton}
              onClick={() => openAccountPasswordSettings()}
            >
              Set password in Account settings
            </Button>
            <button
              type="button"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              data-testid={testIds.inbox.passwordSetupDismiss}
              onClick={onDismiss}
            >
              Dismiss
            </button>
          </div>
        </div>
        <button
          type="button"
          className="shrink-0 rounded p-0.5 text-muted-foreground hover:text-foreground"
          aria-label="Dismiss password reminder"
          onClick={onDismiss}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  )
}
